import { Col, Row } from 'antd';
import { ReactComponent as DetailsIcon } from '../../../../../assets/icons/save-2.svg';
import SvgConverter from '../../../../components/Common/SvgConverter';
import CollapsiblePanel from '../../../../components/Tabs/CollapsiblePanel';
import PreClaimsDetailsForm from './Tabs/Details/PreClaimsDetailsForm';
import PreClaimsFiles from './Tabs/Files/PreClaimsFiles';
import PreClaimsItems from './Tabs/Items/PreClaimsItems';
import PreClaimsNotes from './Tabs/Notes/PreClaimsNotes';

const CreatePreClaimsTab = ({
  activeKey,
  setActiveKey,
  detailsForm,
  notesList,
  setNotesList,
  filesList,
  setFilesList,
  itemList,
  setItemList,
  initiateSubmitProcess,
  onFieldsChange,
  initialValues,
}) => {
  return (
    <CollapsiblePanel
      forceRender
      handleTabClick={(keys) => setActiveKey(keys)}
      activeKey={activeKey}
      tabs={[
        {
          tabKey: '1',
          content: (
            <PreClaimsDetailsForm
              detailsForm={detailsForm}
              initiateSubmitProcess={initiateSubmitProcess}
              onFieldsChange={onFieldsChange}
              initialValues={initialValues}
            />
          ),
          header: <GenerateTitle title="Details" Icon={DetailsIcon} size={25} />,
        },
        {
          tabKey: '2',
          content: <PreClaimsItems itemList={itemList} setItemList={setItemList} onFieldsChange={onFieldsChange} />,
          header: <GenerateTitle title="Claim Items" Icon={DetailsIcon} size={25} />,
        },
        {
          tabKey: '3',
          content: <PreClaimsNotes notesList={notesList} setNotesList={setNotesList} onFieldsChange={onFieldsChange} />,
          header: <GenerateTitle title="Claim Notes" Icon={DetailsIcon} size={25} />,
        },
        {
          tabKey: '4',
          content: <PreClaimsFiles filesList={filesList} setFilesList={setFilesList} onFieldsChange={onFieldsChange} />,
          header: <GenerateTitle title="Upload/View Files" Icon={DetailsIcon} size={25} />,
        },
      ]}
    />
  );
};

export default CreatePreClaimsTab;

const GenerateTitle = ({ title, Icon, size = 25 }) => {
  return (
    <Row gutter={10} align="middle">
      <Col className="lh-0">
        <SvgConverter width={size} height={size} Icon={Icon} />
      </Col>
      <Col className="lh-0">
        {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
        <label className="lh-0 text-dark cursor-pointer">{title}</label>
      </Col>
    </Row>
  );
};
